module.exports = __webpack_public_path__ + "static/img/zi3.4401ea2e.png";